module.exports = __webpack_public_path__ + "media/images/icon_list/grip_vertical-08bc1723d6284958776f262df1d398d5.svg";